module.exports = __webpack_public_path__ + "img/enterprise.e8009a5a.png";